import React from 'react';
import CoursesList from './list/index';

const CoursesListPage = () => {
  return <CoursesList />;
};

export default CoursesListPage;
